import React from 'react';

import { TaskResponse } from '../../client';

import { FeatureBadge } from '../atoms';

interface TaskCardProps {
  task: TaskResponse;
  children: React.ReactNode;
  inaccessible?: boolean;
}

export function TaskCard({ task, children, inaccessible = false }: TaskCardProps) {
  const title =
    task.type === 'dice'
      ? 'Roll the dice to reach the target score'
      : task.type === 'equation'
        ? 'Solve the equation'
        : task.type === 'memory'
          ? 'Find all pairs of cards'
          : '';

  return (
    <div className="min-w-[300px] max-w-[98vw] mt-2 mx-2 rounded-lg border border-border-default bg-bg-elevated shadow-sm">
      <div className="p-4 pb-2">
        <div className="flex items-center justify-between mb-4">
          <samp className="text-text-secondary">{task.id}</samp>
          <FeatureBadge featureId={task.feature_id} />
        </div>
        <h3 className="text-sm font-semibold text-center">{inaccessible ? 'Task not accessible' : title}</h3>
        <hr className="border-border-default mt-3" />
      </div>
      <div className="p-4 pt-0">{children}</div>
    </div>
  );
}
